
import Vue, { VNode, CreateElement } from "vue";

export default Vue.extend({
  props: {
    args: Object as () => any,
    count: Number as () => number | undefined,
  },
  render(h: CreateElement): VNode {
    // getting the inner text must be called explicitly, e.g. a computed `key` returning the
    // slot's content won't update and always return the initial value
    const key = this.$slots.default && this.$slots.default[0].text?.trim();

    if (!key) {
      return h("strong", "NO KEY PROVIDED");
    }

    // todo
    const isProduction = (process.env.NODE_ENV == "production");
    const attrs = isProduction ? {} : { title: key };
    const text = typeof this.count !== "undefined" ? this.$tc(key, this.count, this.args) : this.$t(key, this.args);

    return h("span", { attrs }, text.toString());
  },
});
